import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import { FontColor, FourGround } from "../../../assets/js/theme";
import {
  ArrowClockwise,
  FilterCircle,
  PenFill,
  Plus,
  ThreeDots,
} from "react-bootstrap-icons";
import Loader from "../../../components/common/Loader";
import Table from "../../../components/table/Table";
import { useDispatch, useSelector } from "react-redux";
import useDash from "../../../assets/css/dash.module.css";
import ServerDialog from "./ServerDialog";
import { getNetFeeServer } from "../../../features/apiCallAdmin";

const Server = () => {
  const dispatch = useDispatch();

  //---> Get netFee servers from redux store
  const servers = useSelector((state) => state.admin?.server);

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [serverData, setServerData] = useState({});

  useEffect(() => {
    !servers?.length && getNetFeeServer(dispatch, setIsLoading);
  }, []);

  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: "#",
        id: "row",
        accessor: (row, index) => index,
        Cell: ({ row, data }) => <strong>{data.length - row.index}</strong>,
      },
      {
        Header: "Type",
        width: "15%",
        accessor: "serverType",
      },
      {
        Header: "url",
        width: "8%",
        accessor: "url",
      },
      {
        width: "10%",
        Header: () => <div className="text-center">Action</div>,
        id: "option",
        Cell: ({ row: { original } }) => (
          <div className="d-flex justify-content-center align-items-center">
            <ThreeDots
              className="dropdown-toggle ActionDots"
              id="areaDropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />
            <ul className="dropdown-menu" aria-labelledby="customerDrop">
              <li
                onClick={() => {
                  setModalStatus("serverDialog");
                  setIsUpdate(true);
                  setServerData(original);
                  setShow(true);
                }}
              >
                <div className="dropdown-item actionManager">
                  <div className="customerAction">
                    <PenFill />
                    <p className="actionP">Edit</p>
                  </div>
                </div>
              </li>

              {/* <li onClick={() => handleNetworkDeviceDelete(original.id)}>
                <div className="dropdown-item actionManager">
                  <div className="customerAction">
                    <ArchiveFill />
                    <p className="actionP">{t("delete")}</p>
                  </div>
                </div>
              </li> */}
            </ul>
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div className="component_name">Server</div>

                  <div className="d-flex align-items-center">
                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title="Refresh"
                          //   onClick={reloadHandler}
                        />
                      )}
                    </div>

                    <div
                      onClick={() => {
                        setModalStatus("serverDialog");
                        setShow(true);
                        setIsUpdate(false);
                      }}
                    >
                      <Plus className="addcutmButton" />
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="mt-2">
                  <div className="collectorWrapper pb-2">
                    <Table
                      isLoading={isLoading}
                      columns={columns}
                      data={servers}
                    />
                  </div>
                </div>
              </FourGround>
            </FontColor>
          </div>
        </div>
      </div>

      {/* Server Dialog */}
      {modalStatus === "serverDialog" && (
        <ServerDialog {...{ show, setShow, isUpdate, server: serverData }} />
      )}
    </>
  );
};

export default Server;
